import '@awesome.me/webawesome/dist/components/button/button.js';

import { useTranslation } from 'react-i18next';

import type { ExtractedItem } from '../../services/extraction.js';

interface ItemConfirmationProps {
  items: ExtractedItem[];
  onConfirm: (items: ExtractedItem[]) => void;
  onRemove: (index: number) => void;
}

export function ItemConfirmation({ items, onConfirm, onRemove }: ItemConfirmationProps) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return (
      <div style={{ maxWidth: '480px', margin: '0 auto', padding: 'var(--space-xl)', textAlign: 'center' }}>
        <p style={{ color: 'var(--color-text-secondary)' }}>{t('onboarding:confirmation.empty')}</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '480px', width: '100%', margin: '0 auto', padding: 'var(--space-xl)' }}>
      <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', marginBottom: 'var(--space-sm)' }}>
        {t('onboarding:confirmation.title')}
      </h2>
      <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.875rem', marginBottom: 'var(--space-lg)' }}>
        {t('onboarding:confirmation.subtitle')}
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
        {items.map((item, i) => (
          <div
            key={i}
            style={{
              background: 'var(--color-card)',
              border: '1px solid var(--color-card-border)',
              borderRadius: 'var(--radius-md)',
              padding: 'var(--space-md)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, marginBottom: 'var(--space-xs)' }}>{item.text}</div>
                {item.category && (
                  <span style={{ fontSize: '0.75rem', color: 'var(--color-text-secondary)' }}>
                    {item.category}
                  </span>
                )}
                {item.effort && (
                  <span style={{ fontSize: '0.75rem', color: 'var(--color-text-secondary)', marginLeft: 'var(--space-sm)' }}>
                    {t(`items:effort.${item.effort}`)}
                  </span>
                )}
              </div>
              <wa-button
                size="small"
                variant="neutral"
                appearance="text"
                onClick={() => { onRemove(i); }}
                aria-label={`${t('onboarding:confirmation.removeItem')} ${item.text}`}
              >
                ✕
              </wa-button>
            </div>
            {item.consequence && (
              <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', marginTop: 'var(--space-xs)' }}>
                {item.consequence}
              </p>
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: 'var(--space-lg)', textAlign: 'right' }}>
        <wa-button variant="brand" onClick={() => { onConfirm(items); }}>
          {t('onboarding:confirmation.addAll')}
        </wa-button>
      </div>
    </div>
  );
}
